import clsx from 'clsx';
import React from 'react';

const PageTitle = ({
  title,
  description,
  className,
  classNames,
}: {
  title: string | React.ReactNode;
  description?: string | React.ReactNode;
  className?: string;
  classNames?: {
    title?: string;
    description?: string;
  };
}) => {
  return (
    <div
      className={clsx(
        'my-8 md:my-section max-w-[872px] text-center mx-auto',
        className
      )}
    >
      {React.isValidElement(title) ? (
        title
      ) : (
        <h2
          className={clsx(
            'text-dark font-bold text-[32px] md:text-[48px]',
            classNames?.title
          )}
        >
          {title}
        </h2>
      )}
      {React.isValidElement(description) ? (
        description
      ) : (
        <p
          className={clsx(
            'h6 mt-8 text-gray-dark text-center text-[17px] md:text-[20px]',
            classNames?.description
          )}
        >
          {description}
        </p>
      )}
    </div>
  );
};

export default PageTitle;
